import React, { useCallback, useEffect, useRef, useState } from 'react'
import { FaqEntryListService } from '../../../../services/Faq/FaqEntryListService';

export const UseHookfaq = () => {
    const [activeTab, setActiveTab] = useState("ACCOUNT_RELATED");
    const [entryList, setEntryList] = useState(null);
    const [entryVideoList, setEntryVideoList] = useState(null);
    //Call the service API
    const FaqListService = useRef(FaqEntryListService());
    const didRun = useRef(false);
    useEffect(() => {
        if (!didRun.current) {
            if (activeTab === "ACCOUNT_RELATED") {
                TabOnCLick_FaqEntryList("TEXT", activeTab);
                TabOnCLick_FaqEntryList_VIDEO("VIDEO", activeTab);
                didRun.current = true;
            }
        }
    }, []);

    const TabOnCLick_FaqEntryList = useCallback(
        async (type, category) => {
            try {

                const payload = { type, category };
                const response = await FaqListService?.current.FaqEntryList(payload);
                setEntryList(response.data);

            } catch (error) {

            }
        }, []
    );
    const TabOnCLick_FaqEntryList_VIDEO = useCallback(
        async (type, category) => {
            try {

                const payload = { type, category };
                const response = await FaqListService?.current.FaqEntryList(payload);

                setEntryVideoList(response.data);

            } catch (error) {

            }
        }, []
    );
    //FaqEntryListService
    const handleTabClick = (tabId) => {

        setEntryList(null);
        setActiveTab("");
        setActiveTab(tabId);
        TabOnCLick_FaqEntryList("TEXT", tabId);
        TabOnCLick_FaqEntryList_VIDEO("VIDEO", tabId);
    };
    return { activeTab, handleTabClick, entryList, TabOnCLick_FaqEntryList, entryVideoList }


}